import { GameGraphicsProps } from '../../Components/GameGraphics/GameGraphics';
import { CategorySectionTileType, GameTypes } from '../../apiTypes/GameService';
import { BannerProps } from '../Badge/Badge';

export interface TileProps {
  id?: string;
  type?: GameTypes;
  bannerInfo?: BannerProps;
  gameGraphics?: GameGraphicsProps;
  favourited?: boolean;
  navigationUrl?: string;
  navigationUrlWithLaunchParam?: string;
  isLoading?: boolean;
  title?: string;
  description?: string;
  subtitle?:string;
  tag?: string;
  minWagerRaw?: number;
  releaseDate?: Date;
  popscore?: number;
  playersText?: string;
  dealerName?: string;
  liveGamesText?: string,
  liveStreamLink?: string,
  primaryButtonHref?: string,
  secondaryButtonHref?: string,
  buttonEnabled?: boolean;
  primaryButtonCallback?: () => void;
  className?: string;
  primaryButtonText?: string;
  secondaryCallback?: () => void;
  secondaryButtonText?: string;
  minWager?: string;
  potSize?: string;
  openFrom?: string;
  isTableClosed?: boolean;
  isUnavailable?: boolean;
  useSecondaryGradient?: boolean;
  index?: number;
  tabIndex?: number;
  onClick?: () => void;
  alias?: string;
  prize?: string;
  winMinutes?: string,
  addToSearchInteractions?: () => void;
}

export const TileTypesEnum = Object.freeze({
  ...CategorySectionTileType,
  MEGA: 'Mega',
  MICRO: 'Micro',
  WINNER: 'Winner',
  ASSET: 'Asset',
} as const);

export type TileTypes = typeof TileTypesEnum[keyof typeof TileTypesEnum];

